import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { ARTICLES, IMAGES } from "@/lib/data";
import { useLang } from "@/i18n";
import { ArrowUpRight } from "lucide-react";

export default function Insights() {
  const { t, data } = useLang();

  return (
    <>
      <SEO
        title="Insights — Apple & Mango Trade Notes | Farmsons"
        description="Insights from Farmsons on India's fruit trade: Himachal apple season outlook, choosing apple rootstock for Himachal & Kashmir, and the mango varieties India exports."
        keywords="Himachal apple season, apple rootstock guide India, Indian mango export varieties, fruit trade insights"
      />
      <PageHeader
        overline={t("insights.overline")}
        title={t("insights.title")}
        lede={t("insights.lede")}
        image={IMAGES.orchardRows}
        imageAlt="Rows of apple trees in a high-density orchard at harvest time"
      />
      <section className="pb-24 md:pb-32 bg-[var(--cream)]">
        <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {ARTICLES.map((a, i) => {
            const da = data.articles?.[a.slug];
            return (
              <Reveal key={a.slug} delay={i * 0.08}>
                <Link to={`/insights/${a.slug}`} data-testid={`article-card-${a.slug}`}
                  className="group h-full bg-white border border-[#1d3a1f]/10 rounded-2xl overflow-hidden card-soft hover:-translate-y-1 hover:border-[#d3a53a] transition-all duration-300 flex flex-col">
                  <div className="relative h-48 overflow-hidden">
                    <img src={a.image} alt={a.imageAlt} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <span className="text-xs font-semibold uppercase tracking-[0.12em] text-[#d3a53a]">{da?.readTime || a.readTime}</span>
                    <h2 className="mt-2 font-display font-bold text-xl text-[#1d3a1f] leading-snug">{da?.title || a.title}</h2>
                    <p className="mt-3 text-sm text-[#5f6b57] leading-relaxed flex-1">{da?.excerpt || a.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1 text-sm font-bold text-[#1d3a1f] group-hover:text-[#d3a53a] transition-colors">{t("insights.read")} <ArrowUpRight size={15} /></span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
}
